import http from "@/axiosConfig";
import toast from "@/global/ToastConfig";
import {ROUTES} from "@/global/api_routes";
import {orderMenu, processData} from "@/layout/full/sidebar/SideBar";

const menuRoute = {
    GET_MENU_ALL: "dashboard/safe/account/menu-all",
};


export default {
    listMenu() {
        let newInfo = [];
        return new Promise(resolve => {
            http.get(menuRoute.GET_MENU_ALL)
                .then(({data}) => {
                    const code = data.code;
                    if (code === 0) {
                        toast.info("No se encontró el menú del usuario");
                        return;
                    }
                    if (code < 0) {
                        toast.error("Error al consultar el menú del usuario");
                        return;
                    }
                    newInfo = data.info;
                })
                .catch(() => toast.error("Error al consultar el menú del usuario"))
                .finally(() => resolve(newInfo))
        });
    },
};